import { FC } from 'react';
import { MediaManager } from 'src/manager/MediaManager';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    styles: Styles;
    data: { src: string }[];
  };
};
const CerificateList: FC<Props> = ({ settings }) => {
  const { styles, data } = settings;

  return (
    <div className="cerificateList_container" style={styles}>
      <div className="liner" />
      {data?.map((d) => {
        return <img key={d.src} src={MediaManager.getSrcFromMediaAssets(d.src, '/footerIcons/')} alt={d.src} />;
      })}
      <div className="liner" />
    </div>
  );
};
export default CerificateList;
